import React from 'react'

import Box from '@mui/material/Box'

const WaiverFormWrapper = props => {
  const { children } = props

  return (
    <Box p={[2, 4]} bgcolor='grey.200' mt={4}>
      {children}
    </Box>
  )
}

export default WaiverFormWrapper
